/**
 * @file Format de sauvegarde versionne : enveloppe (format, version, revision, checksum) + donnees JSON-safe (Decimal -> BigStr).
 */
import type { BigStr, Decimal } from '@shared/bignum';
import type { PlayerData } from '../state/PlayerData';

/** Version COURANTE du schema. Toute modification de PlayerData incompatible => +1 et une migration dans migrations.ts. */
export const CURRENT_SAVE_VERSION = 1;
export const SAVE_FORMAT = 'catgunner2' as const;

/** Remplace recursivement Decimal par BigStr (forme JSON). */
export type Serialized<T> = T extends Decimal
  ? BigStr
  : T extends Array<infer U>
    ? Array<Serialized<U>>
    : T extends object
      ? { [K in keyof T]: Serialized<T[K]> }
      : T;

/** Donnees de la version courante telles qu'ecrites sur disque. */
export type SaveDataV1 = Serialized<PlayerData>;

export interface SaveEnvelope {
  format: typeof SAVE_FORMAT;
  version: number;
  savedAtMs: number;
  /** = meta.revision au moment de l'ecriture : base de la resolution de conflits de la synchro serveur future. */
  revision: number;
  /** FNV-1a du JSON de `data` : detection de corruption (pas un anti-triche). */
  checksum: string;
  data: unknown;
}
